import React from 'react';
import { connect } from "react-redux";
import SharedSupportTabs from "../default/components/SupportTabs";
import {
    getTicketList,
} from "../../../../redux/ticket/ticketState";
import {
    getItCategoryList,
    getTicketStatusList
} from "../../../../redux/optionlist/optionlistState";

const SupportTabs = (props) => {
    return <SharedSupportTabs variant="it-support" {...props} />;
};

const mapStateToProps = (state) => ({
    recordList: state.ticket.ticketList?.items,
    pagination: state.ticket.ticketList?.pagination,
    filters: state.ticket.ticketList?.filters,
    categoryData: state.optionlist.itCategoryList?.items,
    ticketStatus: state.optionlist.ticketStatusList?.items,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTicketList(filters)),
    getCategory: (data) => dispatch(getItCategoryList(data)),
    getTicketStatus: (data) => dispatch(getTicketStatusList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupportTabs);